module.exports = __webpack_public_path__ + "static/00098.42a1b5a4.jpg";